import { useState } from 'react';

export const useStatisticsV2Screen = () => {
  const [selectedKey, setSelectedKey] = useState('Incoming');
  const [showIncoming, setShowIncoming] = useState(true);

  const handleDataUpdate = (key: string) => {
    switch (key) {
      case 'Incoming':
        setSelectedKey('Incoming');
        setShowIncoming(true);
        break;
      case 'Outgoing':
        setSelectedKey('Outgoing');
        setShowIncoming(false);
        break;
    }
  };

  return {
    selectedKey,
    onUpdateData: handleDataUpdate,
    showIncoming,
  };
};
